var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTypekit = function SvgTypekit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#typekit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87EC00",
    d: "M16 0H0v16h16V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152600",
    d: "M15.153.824H.8v14.303h14.353V.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87EC00",
    d: "M5.173 5.235h-1.74c-.046 0-.093-.048-.093-.096l.093-.873c0-.048.047-.096.094-.096H7.76c.047 0 .047 0 .093.048v.048l.094.873c0 .048 0 .048-.047.096H6.26v6.06c0 .047-.047.095-.093.095h-.94c-.047 0-.094-.048-.094-.096l.04-6.06Zm4.567 3.25L11.293 6.3c0-.048.047-.048.094-.048h1.033c.093 0 .093.048.047.096-.234.336-1.367 1.745-1.74 2.184v.097l1.973 2.665c.047.048 0 .096-.047.096H11.48c-.047 0-.093-.048-.093-.096-.327-.44-1.174-1.697-1.6-2.28v2.28c0 .048 0 .048-.047.096h-.987c-.046 0-.046 0-.093-.048V4.266c0-.048 0-.048.047-.096h.986c.047 0 .094.048.094.096L9.74 8.484Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "typekit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTypekit);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;